<template>
<div id="whatsapp" class="whatsapp">
  <div class="whatsapp-tabs">
    <!--<div class="whatsapp-tab" @click="activeTabs('whatsapp')" :class="isWhatsapp ? 'active' : ''">
      <i class="icon-whatsup"></i> Whatsapp
    </div>-->
    <div class="whatsapp-tab" >
      <i class="icon-comment-2"></i> Anotações
    </div>
    <div class="whatsapp-close">
      <button @click="whatsappClose()"><div class="icon-close"></div></button>
    </div>
  </div>
  <!--
  <div v-if="isWhatsapp" class="whatsapp-header">
    <div class="whatsapp-user-information">
      <div class="container-user-information">
        <img v-if="customerProfilePicture" :src="customerProfilePicture" @error="(() => customerProfilePicture = null)" />
        <div v-else class="profile-name">{{ parseFirstLetterProfileFullName(customerName) }}</div>
        <h2>{{ customerName }}</h2>
      </div>
      <div class="container-phone-numbers">
        <div @click="openPhoneNambers()" class="phone-selected">
          {{ phone }} <i class="icon-arrow-1-down"></i>
        </div>
        <ul class="phone-numbers" :class="phoneNambersModal ? 'open' : ''">
          <template v-for="phone in phones">
            <li v-if="!phone.disabled" :key="phone.id" :class="phone.selected ? 'selected' : ''" @click="selectedPhoneNumber(phone.phoneNumber)">{{ phone.phoneNumber }}</li>
          </template>
          <li @click="contactOpen()" class="phone-numbers-edit">Editar dados</li>
        </ul>
      </div>
    </div>
  </div>
  <div v-if="isWhatsapp" id="whatsapp-body" class="whatsapp-body" ref="whatsappBody">
    <div class="message-day" v-if="dateMsgs">
       <div class="message-day-content"> {{ dateMsgs }} </div>
    </div>
    <div v-for="(msg, index) in msgs" :key="msg.id">
      <div class="message-day">
        <div class="message-day-content" v-if="msgs[index - 1] && msgs[index - 1].contactDate !== msg.contactDate">{{ msg.contactDate }}</div>
      </div>
      <div class="whatsapp-messages" :class="[(msg.direction === 'ENVIADO' ? 'whatsapp-messages-client' : ''), (msg.direction === 'RECEBIDO' ? 'whatsapp-messages-server' : '')]">
        <div class="whatsapp-messages-body" :class="[(msg.direction === 'ENVIADO' ? 'client-message' : ''), (msg.direction === 'RECEBIDO' ? 'server-message' : '')]">
          <div class="chat-bubble-whatsappname" v-if="msg.direction === 'RECEBIDO'"> {{ msg.whatsappName ? msg.whatsappName + " (OFICIAL)" : msg.whatsappName }} </div>
          <div class="chat-bubble-whatsappname" v-if="msg.direction === 'ENVIADO'"> {{ msg.agentName ? msg.agentName : '' }} </div>
          <span v-html="msg.message" v-linkified></span>
          <div class="message-time">{{ messageId === msg.id ? msg.data : showDateHour(msg.data) }}</div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="isWhatsapp" class="whatsapp-footer">
    <div class="whatsapp-message-container">
      <textarea
        v-model="messageWhats"
        @keydown.enter="shortcutMessage($event)"
        @keydown="textareaResize($event)"
        class="whatsTextArea"
        id="whatsTextArea"
        name="messageWhats"
        ref="inputTextarea"
        rows="1"
      ></textarea>
      <button @click="sendMessage">
        <div v-if="loading" class="spinner-border spinner-border-sm send-message-loading" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <span v-else>Enviar</span>
      </button>
    </div>
    <div class="whatsapp-message-history" :class="whatsappMessageHistory ? 'active' : ''">
      <div class="whatsapp-message-history-header" :class="whatsappMessageHistory ? '' : 'active'">
        <h3>Mensagens salvas</h3>
        <span>
          <button @click="openWhatsappMessageHistory"><i :class="whatsappMessageHistory ? 'icon-arrow-1-down' : 'icon-arrow-1-up'"></i></button>
          <div class="button-text" @click.stop="openWhatsappMessageHistory">{{ whatsappMessageHistory ? 'Fechar' : 'Abrir' }}</div>
        </span>
      </div>
      <template v-if="dynamicMessages.length">
        <div class="whatsapp-message-list" v-if="whatsappMessageHistory">
          <div v-for="msg in dynamicMessages" :key="msg.id">
            <div class="whatsapp-message-item">
              <div class="whatsapp-message-item-title"><strong>{{ msg.title }}</strong></div>
              <div class="whatsapp-message-item-message">
                <p :id="`whatsapp-view-more-${msg.id}`">{{ msg.message }}</p>
                <a @click="openViewMore(msg.id)"><span :id="`whatsapp-view-collapse-${msg.id}`">Ver mais</span></a>
              </div>
              <div class="whatsapp-message-item-button">
                <button @click="sendDynamicMessage(msg.message, msg.id)" :disabled="prevent">
                  <div :id="`whatsapp-button-loading-${msg.id}`" class="" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                  <i :id="`whatsapp-button-icon-${msg.id}`" class="icon-paper-plane-2"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="no-menssage">Carregando mensagens</div>
      </template>
    </div>
  </div>
  -->
  <notes-customer-component
    v-if="isNotes"
    :id="id"
  />
</div>
</template>
<script>
import moment from 'moment-timezone'
import { extractFirstName } from '../../../utils/extractFirstName'
import { parseFirstLetterProfileFullName } from '../../../utils/parseFirstLetterProfileFullName'
import NotesCustomer from '../../partial/customer/NotesCustomer.vue'

export default {
  components: {
    'notes-customer-component': NotesCustomer
  },
  data () {
    return {
      load: false,
      messageWhats: '',
      transaction: null,
      selectedPhone: null,
      data: [],
      msgs: [],
      options: [],
      phones: [],
      phone: '',
      phoneNambersModal: false,
      numMsgs: 0,
      timer: '',
      isProtocol: false,
      digitalkSelected: false,
      loading: false,
      messageId: null,
      searchEmoji: '',
      totalMsgs: 0,
      tempMsgs: 0,
      dateMsgs: null,
      whatsappMessageHistory: false,
      viewMore: '',
      dynamicMessages: [],
      prevent: false,
      onClickClose: false,
      isWhatsapp: false,
      isNotes: true
    }
  },
  mounted () {
    if (this.$route.params.txid || this.id) {
      this.onLoad()
      this.getDynamicMessages()
    }
    this.$root.$on('onLoad', () => {
      this.onLoad()
      this.getDynamicMessages()
    })
    this.timer = setInterval(this.refreshMessageList, 30000)
    this.$root.$on('protocolNumber', (protocol) => {
      if (protocol !== null) {
        this.isProtocol = true
        this.load = true
        this.msgs = []
        this.numMsgs = 0
        this.getProtocolMessages(protocol)
      }
    })
    this.$root.$on('updateWhatsappScreen', () => {
      this.msgs = []
      this.isProtocol = false
      this.numMsgs = 0
      this.totalMsgs = 0
      // this.getMessages(this.selectedPhone)
      var body = document.body
      body.classList.remove('aside-menu-lg-show')
    })
    this.$root.$on('updateWhatsappMessages', () => {
      if (this.selectedPhone) {
        // this.getMessages(this.selectedPhone)
      }
    })
    this.$root.$on('validationWhats', (phone) => {
      this.msgs = []
      this.selectedPhone = phone
      this.load = true
      this.isProtocol = true
      this.numMsgs = 0
      this.totalMsgs = 0
      // this.getMessages(this.selectedPhone)
    })

    this.getPhones()

    this.$emit('onOpen')

    if (this.splitMessage) {
      // this.messageWhats = this.splitMessage
      setTimeout(() => {
        this.sendMessage()
      }, 1500)
      this.$refs.inputTextarea.rows = 5
    }
  },
  methods: {
    parseFirstLetterProfileFullName,
    extractFirstName,
    sendDynamicMessage (msg, id) {
      let loading = document.getElementById(`whatsapp-button-loading-${id}`)
      loading.classList.add('spinner-border')
      loading.classList.add('spinner-border-sm')
      loading.classList.add('send-message-loading')

      let icon = document.getElementById(`whatsapp-button-icon-${id}`)
      icon.style.display = 'none'

      this.prevent = true

      this.$http.post(`api/chat/${this.$route.params.txid ? this.$route.params.txid : this.id}/shorten-boletos-link`)
        .then(function (res) {
          let msgUpdated = msg.replace('@linkBoletos', res.data.link)

          this.$http.post('api/chat', {message: msgUpdated, phone: this.selectedPhone, transaction: this.transaction, username: this.$auth.user().username, unofficial: this.digitalkSelected, isHSM: true})
            .then(function (res) {
              this.$bvToast.toast('Mensagem enviada com sucesso', {
                autoHideDelay: 5000,
                variant: 'success'
              })

              icon.style.display = 'block'
              loading.classList.remove('spinner-border')
              loading.classList.remove('spinner-border-sm')
              loading.classList.remove('send-message-loading')
              this.prevent = false
              // this.getMessages(this.selectedPhone)
              this.whatsappMessageHistory = false
            })
            .catch(function (res) {
              console.error(res)
              this.$bvToast.toast(res, {
                title: 'Erro ao enviar mensagem',
                autoHideDelay: 5000,
                variant: 'danger'
              })
              icon.style.display = 'block'
              loading.classList.remove('spinner-border')
              loading.classList.remove('spinner-border-sm')
              loading.classList.remove('send-message-loading')
              this.prevent = true
              this.whatsappMessageHistory = false
            })
        })
        .catch(function (res) {
          console.error(res)
          this.$bvToast.toast(res, {
            title: 'Erro ao enviar mensagem',
            autoHideDelay: 5000,
            variant: 'danger'
          })
          icon.style.display = 'block'
          loading.classList.remove('spinner-border')
          loading.classList.remove('spinner-border-sm')
          loading.classList.remove('send-message-loading')
          this.prevent = true
        })
    },
    getPhones () {
      this.$http.get(`api/validations/${this.$route.params.txid ? this.$route.params.txid : this.id}/phones`)
        .then(function (res) {
          this.phones = res.data.list

          this.phones.forEach(phone => {
            if (phone.defaultPhoneNumber) {
              this.phone = phone.phoneNumber
            }
          })

          this.phones = this.phones.sort(function (a, b) {
            return (a.defaultPhoneNumber === b.defaultPhoneNumber) ? 0 : a.defaultPhoneNumber ? -1 : 1
          })
        })
        .catch(function (res) {
          console.error(res)
        })
    },
    selectedPhoneNumber (number) {
      this.phone = number
      this.phoneNambersModal = !this.phoneNambersModal
      this.phones.forEach((phone, index) => {
        if (phone.phoneNumber === number) {
          this.phones[index].selected = 'selected'
        } else {
          this.phones[index].selected = ''
        }
      })
      this.selectedPhone = number
      this.msgs = []
      this.numMsgs = 0
      // this.getMessages(this.selectedPhone)
    },
    contactOpen () {
      this.$emit('emitContactOpen')
    },
    openPhoneNambers () {
      this.phoneNambersModal = !this.phoneNambersModal
    },
    getDynamicMessages () {
      moment.locale('pt-br')

      if (!this.nextInstallment) {
        this.$emit('emit-clean-next-installment')
      }

      this.$http.get('api/chat/default-messages')
        .then(function (res) {
          if (res.data.list) {
            res.data.list.map(msg => {
              if (this.nextInstallment) {
                this.dynamicMessages.push({
                  id: msg.id,
                  title: msg.title,
                  message: msg.message
                    .replace('@name', this.extractFirstName(this.customerName))
                    .replace('@seller', this.seller)
                    .replace('@reference', this.reference)
                    .replace('@number/totalInstallments', '*' + this.nextInstallment.installment + '*/*' + this.totalInstallments + '*')
                    .replace('@dateSettled', moment(this.nextInstallment.dueDate).format('DD/MM/YYYY'))
                    .replace('@linkInstallments', '@linkBoletos') // `https://meu.boletoflex.com/#/${this.$route.params.txid}`
                })
              } else {
                this.dynamicMessages.push({
                  id: msg.id,
                  title: msg.title,
                  message: msg.message
                    .replace('@name', this.extractFirstName(this.customerName))
                    .replace('@seller', this.seller)
                    .replace('@reference', this.reference)
                    // .replace('@number/totalInstallments', '*' + this.nextInstallment.installment + '*/*' + this.totalInstallments + '*')
                    // .replace('@dateSettled', moment(this.nextInstallment.dueDate).format('DD/MM/YYYY'))
                    .replace('@linkInstallments', '@linkBoletos') // `https://meu.boletoflex.com/#/${this.$route.params.txid}`
                })
              }
            })

            this.dynamicMessages.map((msg, index) => {
              if (msg.message.indexOf('undefined') !== -1) {
                this.dynamicMessages.splice(index, 1)
              }
            })
          }
        })
        .catch(function (res) {
          console.error(res)
        })
    },
    whatsappClose () {
      this.$emit('emitWhastappClose', false)
    },
    whatsappScrollbarChat () {
      let el = this.$refs.whatsappBody
      el.scrollTop = el.scrollHeight
    },
    activeTabs (tab) {
      switch (tab) {
        case 'whatsapp':
          this.isWhatsapp = true
          this.isNotes = false
          break
        case 'notes':
          this.isNotes = true
          this.isWhatsapp = false
          break
      }
    },
    textareaResize () {
      const textarea = document.getElementById('whatsTextArea')

      textarea.addEventListener('input', function (e) {
        this.style.height = 'auto'
        this.style.height = this.scrollHeight + 'px'
      })
      // var key = e.which || e.keyCode

      // if (this.$refs.inputTextarea.scrollHeight > this.$refs.inputTextarea.offsetHeight && this.$refs.inputTextarea.scrollHeight < 241) {
      //   this.$refs.inputTextarea.rows += 1
      // }
      // if ((key === 8 && this.$refs.inputTextarea.scrollHeight < 241) || (e.target.value.length === 0)) {
      //   this.$refs.inputTextarea.rows -= 1
      // }
      // if (e.ctrlKey && key === 86 && this.$refs.inputTextarea.offsetHeight < 140) {
      //   this.$refs.inputTextarea.rows += 5
      // }
      // if (e.shiftKey && key === 13 && this.$refs.inputTextarea.scrollHeight < 220) {
      //   this.$refs.inputTextarea.rows += 1
      // }
    },
    insertEmoji (emoji) {
      this.messageWhats += emoji
    },
    getMessageId (id) {
      this.msgs.map(msg => {
        if (id === msg.id) {
          this.messageId = id
        }
      })
    },
    whatsServiceSelected (value) {
      this.$store.dispatch('whatsServiceSelected', value)
    },
    messageDefault () {
      this.messageId = null
    },
    showDateHour (date) {
      return date.substring(11, 16)
    },
    shortcutMessage (e) {
      var key = e.which || e.keyCode

      if (e.ctrlKey && key === 13) {
        this.messageWhats = e.target.value + '\n'
        return true
      }
      if (e.shiftKey && key === 13) {
        this.messageWhats = e.target.value
        return true
      }
      if (key === 13) {
        this.sendMessage()
        this.messageWhats = ''
        e.preventDefault()
      }
    },
    getProtocolMessages (protocolNumber) {
      this.$http.get('api/protocol/' + protocolNumber)
        .then(function (res) {
          this.msgs = res.data.protocolNumber
          this.selectedPhone = res.data.protocolNumber[0].phone
        })
        .then(function () {
          this.whatsappScrollbarChat()
          this.tempMsgs = this.msgs.length
        })
        .catch(function (res) {
          console.error(res)
        })
    },
    sendMessage () {
      this.loading = true
      this.$http.post('api/chat', {message: this.messageWhats, phone: this.selectedPhone, transaction: this.transaction, username: this.$auth.user().username, unofficial: this.digitalkSelected, agentName: this.$auth.user().displayName})
        .then(function (res) {
          this.messageWhats = ''
          // this.getMessages(this.selectedPhone)
          this.loading = false
          this.$refs.inputTextarea.rows = 2
          setTimeout(() => {
            this.whatsappScrollbarChat()
          }, 3000)
        })
        .catch(function (res) {
          console.error(res)
          this.loading = false
        })
    },
    async getMessages (phone) {
      // return null
      this.$emit('emit-loading', true)
      if (this.msgs !== undefined && this.numMsgs === 0) {
        this.msgs.splice(0, this.msgs.length)
        setTimeout(() => {
          this.whatsappScrollbarChat()
        }, 1000)
      }
      await this.$http.get('api/chat/' + phone)
        .then(function (res) {
          this.data = res.data
          if (this.numMsgs === 0) {
            Object.values(this.data).forEach((value, index) => {
              this.msgs.push(value)
              this.dateMsgs = this.msgs[0].contactDate
            })
            this.numMsgs = this.msgs.length - 1
          } else {
            Object.values(this.data).forEach((value, index) => {
              if (index > this.numMsgs) {
                this.msgs.push(value)
                this.dateMsgs = this.msgs[0].contactDate
              }
            })
            this.numMsgs = this.msgs.length - 1
          }
          this.totalMsgs = this.msgs.length
        })
        .then(function () {
          if (this.tempMsgs < this.totalMsgs) {
            this.whatsappScrollbarChat()
            this.tempMsgs = this.msgs.length
          }
        })
        .catch(function (res) {
          console.error(res)
        })
      this.$emit('emit-loading', false)
    },
    onLoad () {
      if (this.$route.params.txid || this.id) {
        this.options.splice(0, this.options.length)
        this.load = true
        this.$http.get(`api/transactions/${this.$route.params.txid ? this.$route.params.txid : this.id}`)
          .then(function (res) {
            this.transaction = res.data.tx.id
            this.options.push({value: res.data.validation.defaultPhoneNumber, text: '+55' + res.data.validation.defaultPhoneNumber})
            this.selectedPhone = res.data.validation.defaultPhoneNumber
            this.msgs.splice(0, this.msgs.length)
            this.numMsgs = 0
            this.digitalkSelected = false
            this.totalMsgs = 0
            // this.getMessages(this.selectedPhone)
            this.$http.get(`api/validations/${this.$route.params.txid ? this.$route.params.txid : this.id}/phones`)
              .then(function (res) {
                res.data.list.forEach((value, index) => {
                  var isExist = false
                  this.options.forEach((item, index) => {
                    if (item.value === value.phoneNumber) {
                      isExist = true
                    }
                    if (!isExist) {
                      this.options.push({value: value.phoneNumber, text: '+55' + value.phoneNumber})
                    }
                  })
                })
              })
              .catch(function (res) {
                console.error(res)
              })
          })
          .catch(function (res) {
            console.error(res)
          })
      } else {
        this.load = false
      }
    },
    selecionouTelefone (value) {
      this.msgs = []
      this.numMsgs = 0
      // this.getMessages(value)
    },
    refreshMessageList () {
      if (this.isProtocol) {
        this.isProtocol = true
      }
      if (this.load) {
        // this.getMessages(this.selectedPhone)
      }
    },
    openWhatsappMessageHistory () {
      this.whatsappMessageHistory = !this.whatsappMessageHistory
    },
    openViewMore (id) {
      let view = document.getElementById(`whatsapp-view-more-${id}`)
      let collapse = document.getElementById(`whatsapp-view-collapse-${id}`)

      if (view.className === 'view-more') {
        view.classList.remove('view-more')
        collapse.innerText = 'Ver mais'
      } else {
        view.classList.add('view-more')
        collapse.innerText = 'Ver menos'
      }
    }
  },
  watch: {
    'id' () {
      if (this.$route.params.txid || this.id) {
        this.onLoad()
        this.getDynamicMessages()
        this.whatsappScrollbarChat()
      }
    },
    'whatsappScrollbar' () {
      this.whatsappScrollbarChat()
    },
    'splitMessage' () {
      // this.messageWhats = this.splitMessage
      this.$refs.inputTextarea.rows = 5
      document.getElementById('whatsTextArea').focus()
    }
  },
  props: [
    'id',
    'whatsappScrollbar',
    'customerName',
    'customerProfilePicture',
    'splitMessage',
    'seller',
    'reference',
    'nextInstallment',
    'totalInstallments'
  ],
  beforeDestroy: function () {
    clearInterval(this.timer)
  }
}
</script>
<style lang="scss" scoped>

.whatsapp {
  width: calc(30% - 17px);
  border-radius: 16px;
  margin-left: 17px;
  float: right;
  background-color: #FFFFFF;
  .whatsapp-tabs {
    border-radius: 16px 16px 0 0;
    //background-color: rgba(66, 133, 244, 0.1);
    .whatsapp-tab {
      display: inline-flex;
      align-items: center;
      padding: 20px;
      color: #1C56E0;
      border-radius: 16px 16px 0 0;
      cursor: pointer;
      i {
        padding-right: 5px;
      }
      &.active {
        background-color: #FFFFFF;
        font-weight: 900;
      }
    }
    .whatsapp-close {
      float: right;
      margin: 20px 10px;
      button {
        width: 24px;
        height: 24px;
        float: right;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 5px;
        margin-top: -2px;
        padding: 0px;
        border: none;
        background: #FFFFFF;
        color: #4285F4;
        outline: none;
        float: right;
        line-height: 1.4em;
        color: rgba(66, 133, 244, 0.75);
        margin-right: 4px;
      }
      .button-text {
        float: right;
        line-height: 1.4em;
        color: rgba(66, 133, 244, 0.75);
        margin-right: 4px;
        cursor: pointer;
      }
    }
  }
  .whatsapp-header {
    padding: 16px;
    .whatsapp-user-information {
      display: flex;
      align-items: center;
      .container-user-information {
        width: -webkit-fill-available;
        display: flex;
        align-items: center;
        img {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          margin: 0 10px 0 0;
          float: left;
        }
        .profile-name {
          width: 50px;
          height: 50px;
          min-width: 50px;
          min-height: 50px;
          border-radius: 50px;
          margin: 0 10px 0 0;
          background-color: #6e58f1;
          color: #FFF;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1rem;
          font-weight: bold;
        }
        h2 {
          margin: 0;
          font-size: 16px;
          color: #000000;
        }
      }
      .container-phone-numbers {
        position: relative;
        .phone-selected {
          width: 118px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 14px;
          color: #1C56E0;
          cursor: pointer;
          i {
            margin-left: 10px;
          }
        }
        .phone-numbers {
          position: absolute;
          right: -14px;
          width: 144px;
          display: none;
          margin-top: 5px;
          padding: 0;
          border-radius: 5px;
          list-style: none;
          font-size: 14px;
          background: #FFFFFF;
          color: #999999;
          box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.15);
          cursor: pointer;
          z-index: 99;
          &.open {
            display: block;
          }
          li {
            padding: 8px 16px;
            border: 1px solid #F9F9F9;
            &.selected {
              font-weight: 900;
              color: #666666;
            }
            &:first-child {
              border-radius: 5px 5px 0 0;
              &::after {
                font-family: 'Simple-Line-Icons-Pro';
                content: '\ee21';
                padding-left: 6px;
                color: #F09B1B;
              }
            }
            &:last-child {
              border-radius: 0 0 5px 5px;
              border: none;
            }
            &:hover {
              font-weight: 400;
              color: #666666;
            }
          }
        }
        .phone-numbers-edit {
          color: #1C56E0;
          &:hover {
            font-weight: 400 !important;
            color: #1C56E0 !important;
          }
        }
      }
    }
  }
  .whatsapp-body {
    height: 500px;
    background-color: #E5DDD5;
    background-image: url('../../../assets/images/bg-chat.png');
    background-blend-mode: soft-light;
    overflow-y: scroll;
    overflow-x: hidden;
    .whatsapp-messages {
      display: flex;
      margin: 2px 20px;
      &.whatsapp-messages-client {
        justify-content: flex-end;
      }
      &.whatsapp-messages-server {
        justify-content: flex-start;
      }
      .whatsapp-messages-body {
        position: relative;
        min-width: 100px;
        max-width: 90%;
        border-radius: 8px;
        margin-bottom: 2px;
        padding: 6px 7px 8px 9px;
        font-size: 14px;
        word-wrap: break-word;
        box-shadow: 0 1px .5px rgba(0,0,0,0.13);
        &.client-message {
          background-color: #DCF7C7;
          &:after {
            right: -16px;
            border-top: 9px solid #DCF7C7;
            transform: rotate(30deg) scaleY(-1);
          }
        }
        &.server-message {
          background-color: #FAFAFA;
          &:after {
            left: -16px;
            border-top: 9px solid #FAFAFA;
            border-radius: 0 20px 0;
            transform: rotate(145deg)
          }
        }
        &:after {
          content: "";
          position: absolute;
          width: 15px;
          height: 30px;
          border: 0 solid transparent;
          border-radius: 0 20px 0;
        }
      }
      .message-time {
        position: relative;
        z-index: 10;
        float: right;
        margin: 5px;
        font-size: 11px;
        color: rgba(0,0,0,0.45);
      }
    }
    &::-webkit-scrollbar {
      width: 5px;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    &::-webkit-scrollbar-thumb {
      background-color: rgba(0,0,0,0.2);
      border-radius: 20px;
    }
    .message-day {
      display: flex;
      justify-content: center;
      .message-day-content {
        border-radius: 8px;
        margin: 20px 0;
        padding: 8px;
        font-size: 12px;
        -webkit-box-shadow: 0 1px 0.5px rgba(0,0,0,.13);
        box-shadow: 0 1px 0.5px rgba(0,0,0,.13);
        background-color: #DCF7C7
      }
    }
    &.whatsapp-height-mobile {
      height: 291px !important;
    }
  }
  .whatsapp-footer {
    position: relative;
    padding: 16px;
    .whatsapp-message-container {
      display: flex;
      justify-content: space-between;

      .whatsTextArea {
        width: -webkit-fill-available;
        min-height: 32px;
        max-height: 68px;
        margin-right: 8px;
        border: 1px solid #8E8E93;
        border-radius: 5px;
        padding: 5px;
        resize: none;
        outline: none;

        &:focus {
          border: 2px solid #4285F4;
        }
        &::-webkit-scrollbar {
          width: 5px;
        }
        &::-webkit-scrollbar-track {
          background: transparent;
        }
        &::-webkit-scrollbar-thumb {
          background-color: rgba(0,0,0,0.2);
          border-radius: 20px;
        }
      }

      button {
        width: 100px;
        height: 32px;
        border-radius: 5px;
        border: none;
        float: left;
        background-color: #1c56e0;
        color: #ffffff;

        .send-message-loading {
          color: #FFF;
          font-size: 5px;
        }
      }
    }
    .whatsapp-message-history {
      margin-top: 20px;
      &.active {
        height: 500px;
        width: 100%;
        max-width: 100%;
        position: absolute;
        bottom: 0;
        margin: 0 0 0 -16px;
        padding-top: 16px;
        border-radius: 20px;
        background: white;
        z-index: 10;
        overflow: hidden;
      }
      .whatsapp-message-history-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
        padding: 16px;
        &.active {
          margin-bottom: 0;
          padding: 0;
        }
        h3 {
          font-size: 14px;
          font-weight: 700;
          color: #666666;
        }
        span {
          button {
            width: 24px;
            height: 24px;
            float: right;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 5px;
            margin-top: -4px;
            padding: 0px;
            border: none;
            background: rgba(66, 133, 244, 0.2);
            color: #4285F4;
            outline: none;
          }
          .button-text {
            float: right;
            line-height: 1.4em;
            color: rgba(66, 133, 244, 0.75);
            margin-right: 4px;
            cursor: pointer;
          }
        }
      }
      .whatsapp-message-list {
        overflow-y: auto;
        height: -webkit-fill-available;
        .whatsapp-message-item {
          display: flex;
          flex-direction: row;
          margin-bottom: 20px;
          padding-bottom: 20px;
          border-bottom: 1px solid #D2D2D2;
          .whatsapp-message-item-title {
            width: 30%;
            padding: 8px 8px 8px 16px;
            color: #666666;
          }
          .whatsapp-message-item-message {
            width: 50%;
            max-width: 50%;
            padding: 8px;
            color: #999999;
              word-wrap: break-word;
            p {
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical;
              &.view-more {
                overflow: initial;
                text-overflow: none;
                display: block;
                -webkit-line-clamp: initial;
                -webkit-box-orient: initial;
              }
            }
            a {
              display: block;
              color: #007bff;
              text-decoration: none;
              background-color: transparent;
              cursor: pointer;
              &:hover {
                color: #0056b3;
                text-decoration: underline;
              }
            }
          }
          .whatsapp-message-item-button {
            padding: 8px 16px 8px 8px;
            button {
              width: 32px;
              height: 32px;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 5px;
              border: none;
              background-color: #1c56e0;
              color: #ffffff;
              font-size: 18px;
            }
          }
        }
        &:last-child {
          margin-bottom: 55px;
          overflow-x: hidden;
        }
        &::-webkit-scrollbar {
          width: 5px;
        }
        &::-webkit-scrollbar-track {
          background: transparent;
        }
        &::-webkit-scrollbar-thumb {
          background-color: rgba(0,0,0,0.2);
          border-radius: 20px;
        }
        .send-message-loading {
          color: #FFF;
          font-size: 5px;
        }
      }
      .no-menssage {
        text-align: center;
      }
    }
  }
  &.whatsapp-scroll {
    width: calc(30% - 95px);
    border-radius: 16px;
    margin-left: 20px;
    float: right;
    background-color: #FFFFFF;
    position: fixed;
    right: 30px;
    top: 76px;
  }
}

.sidebar-minimized {
  #app {
    div {
      .app {
        div {
          .app-body {
            .main {
              .container-fluid {
                div {
                  div {
                    .whatsapp {
                      width: calc(30% - 17px);
                      &.whatsapp-scroll {
                        width: calc(30% - 50px);
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

.chat-bubble-whatsappname {
  font-size: 12px;
  color: #b3b3b3;
}

@media (max-height: 768px) {
  .whatsapp-body {
    height: 292px !important;
  }
  .whatsapp-message-history {
    &.active {
      height: 292px !important;
    }
  }
}

@media (max-width: 1366px) and (max-height: 768px) {
.whatsapp {
  width: calc(30% - 17px);
  &.whatsapp-scroll {
    width: calc(30% - 95px);
  }
}
.sidebar-minimized {
  #app {
    div {
      .app {
        div {
          .app-body {
            .main {
              .container-fluid {
                div {
                  div {
                    .whatsapp {
                      width: calc(30% - 17px);
                      &.whatsapp-scroll {
                        width: calc(30% - 50px);
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
}
</style>



// WEBPACK FOOTER //
// src/components/partial/customer/WhatsappCustomer.vue